import {
	authLogin,
	ForgotPassword,
	GetChannels,
	RefreshToken,
	SelectChannel,
	UpdatePassword,
	authCode,
	tempPhone,
	UpdateOnboarding,
	SetAdminPassword,
	UpdateChannel
} from '../../connection/auth';
import { Action, AsyncAction } from '../../types/actions';
import { Channel, Profile } from '../../types/working-model';

export const SIGN_IN = 'SIGN_IN';
export function signIn(
	email: string,
	password: string,
	two_factor_stored: string | null
): AsyncAction {
	return {
		type: SIGN_IN,
		promise: authLogin(email, password, two_factor_stored),
	};
}

export const SET_TEMP_NUMBER = 'SET_TEMP_NUMBER';
export function setTempNumber(
	number: string,
	temp_profile: string
): AsyncAction {
	return {
		type: SET_TEMP_NUMBER,
		promise: tempPhone(number, temp_profile)
	};
}

export const CONFIRM_CODE = 'CONFIRM_CODE';
export function confirmCode(
	temp_profile: string,
	code: string,
	should_confirm: boolean,
	request_storage: boolean
): AsyncAction {
	return {
		type: CONFIRM_CODE,
		promise: authCode(temp_profile, code, should_confirm, request_storage),
	};
}

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export function forgotPassword(email: string, hostname: string): AsyncAction {
	return {
		type: FORGOT_PASSWORD,
		promise: ForgotPassword(email, hostname),
	};
}

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export function updatePassword(password: string, code: string, cb: () => void): AsyncAction {
	return {
		type: UPDATE_PASSWORD,
		promise: UpdatePassword(password, code, cb),
	};
}

export const SET_PROFILE = 'SET_PROFILE';
export function setProfile(token: string): Action {
	return {
		type: SET_PROFILE,
		payload: token,
	};
}

export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export function refreshToken(token: string): AsyncAction {
	return {
		type: REFRESH_TOKEN,
		promise: RefreshToken(token),
	};
}

export const SIGN_OUT = 'SIGN_OUT';
export function signOut(): Action {
	return {
		type: SIGN_OUT,
		payload: true,
	};
}

export const GET_ADMIN_CHANNELS = 'GET_ADMIN_CHANNELS';
export function getAdminChannels(token: string): AsyncAction {
	return {
		type: GET_ADMIN_CHANNELS,
		promise: GetChannels(token),
	};
}

export const SET_ADMIN_CHANNEL = 'SET_ADMIN_CHANNEL';
export function setAdminChannel(token: string, channel: number): AsyncAction {
	return {
		type: SET_ADMIN_CHANNEL,
		promise: SelectChannel(token, channel),
	};
}

export const UPDATE_CHANNEL = "UPDATE_CHANNEL";
export function updateChannel(token: string, channel: Channel): AsyncAction {
	return {
		type: UPDATE_CHANNEL,
		promise: UpdateChannel(token, channel)
	};
}

export const SET_ADMIN_PASSWORD = "SET_ADMIN_PASSWORD";
export function setAdminPassword(password: string, code: string, cb: () => void): AsyncAction {
	return {
		type: SET_ADMIN_PASSWORD,
		promise: SetAdminPassword(password, code, cb)
	};
}

export const ADD_CHECKLIST_ITEM = 'ADD_CHECKLIST_ITEM';
export function addChecklistItem(token: string, id: number, onboarding: string[], newItem: string): AsyncAction {
	return {
		type: ADD_CHECKLIST_ITEM,
		promise: UpdateOnboarding(token, id, onboarding, newItem)
	};
}

export const CLEAR_CHECKLIST = 'CLEAR_CHECKLIST';
export function clearChecklist(): Action {
	return {
		type: CLEAR_CHECKLIST,
		payload: true
	};
}

export const COMPLETE_WELCOME_ONBOARDING = 'COMPLETE_WELCOME_ONBOARDING';
export function completeWelcomeOnboarding(token: string, id: number, onboarding: string[]): AsyncAction {
	return {
		type: COMPLETE_WELCOME_ONBOARDING,
		promise: UpdateOnboarding(token, id, onboarding, "welcome")
	};
}

export const UPDATE_ADMIN_PROFILE = 'UPDATE_ADMIN_PROFILE';
export function updateAdminProfile(profile: Profile): Action {
	return {
		type: UPDATE_ADMIN_PROFILE,
		payload: profile
	};
}
//TODO: create password from email invite
